import { MultiScreenSlideForm, FormConfig, FormSlide, SlideHolder } from "./MultiScreenSlideForm";
import { RadiusChange } from "./RadiusChange";
import Raphael from "raphael";
import FrontendAjaxCalls, { HoseBuilderGetHosesByDiameter } from "./FrontendAjaxCalls";
import ShoppingcartHandler from "./Shoppingcart";
import CookieHandler, { CookieObject } from "./Cookies";
import ProductGroupAPICalls from "./productgroup/ProductGroupAPICalls";
import NavbarEvents from "./navbar/NavbarEvents";
import Animations from "./shoppingcart/Animations";
import ApiRequestsShoppingCart from "./shoppingcart/ApiRequestsShoppingCart";
import { FormField, TSDataTable } from "./TSDataTable";
import { Category } from "./crm/Category";
import { FuzzySearchRequest, ExactSearchRequest } from "./searchbar/SearchApi";
import ApiRequestsEmployeeUser from "./employeeuser/ApiRequestsEmployeeUser";
import ApiFavorites from "./favorites/ApiFavorites";
import FavoriteModalHandler from "./favorites/FavoriteModalHandler";
// window.SlideForm = SlideForm;
window.MultiScreenSlideForm = MultiScreenSlideForm;
window.FormConfig = FormConfig;
window.FormSlide = FormSlide;
window.SlideHolder = SlideHolder;
window.RadiusChange = RadiusChange;
window.Raph = Raphael;
window.FrontEndAjaxCalls = FrontendAjaxCalls;
window.HoseBuilderGetHosesByDiameter = HoseBuilderGetHosesByDiameter;
window.ShoppingcartHandler = ShoppingcartHandler;
window.CookieObject = CookieObject;
window.CookieHandler = CookieHandler;
window.ProductGroupApiCalls = ProductGroupAPICalls;
window.NavbarEvents = NavbarEvents;
window.Animations = Animations;
window.ApiRequestsShoppingCart = ApiRequestsShoppingCart;
window.TSDataTable = TSDataTable;
window.FormField = FormField;
window.Category = Category;
window.ExactSearchRequest = ExactSearchRequest;
window.FuzzySearchRequest = FuzzySearchRequest;
window.ApiRequestsEmployeeUser = ApiRequestsEmployeeUser;
window.ApiFavorites = ApiFavorites;
window.FavoriteModalHandler = FavoriteModalHandler;
// console.log(window.SlideForm);
// window.FormSlide
